<template>
  <a-layout-content style="padding: 10px">
    <a-spin size="large" :spinning="pageLoading">
      <div style="min-height: 100vh">
        <a-tooltip title="Geri">
          <button class="btn-back">
            <img
              src="../../../assets/imgs/return.png"
              class="back-img"
              @click="goBack"
            />
          </button>
        </a-tooltip>
        
        <problem-header v-if="problem" :problem="problem"></problem-header>

        <a-row type="flex" :gutter="24" v-if="problem">
          <a-col span="24">
            <a-row type="flex" :gutter="24">
              <a-col :span="15" style="height: max-content">
                

                <conditional-media :filesList="problem.files" />

                <p class="username" v-if="problem.addUser">
                  {{
                    problem.addUser.firstName +
                    " " +
                    problem.addUser.lastName +
                    " " +
                    problem.addUser.fatherName
                  }}
                </p>

                <p class="title">{{ problem.title }}</p>

                <p class="date-txt" v-if="problem">
                  {{ problem.dateStr }}
                  <a-icon type="clock-circle" style="margin-right: 7px" />
                </p>

                <div
                  v-if="getCategoriesOfProblem.length > 0"
                  style="display: flex; align-items: center; margin: 0 6px 10px"
                >
                  <p style="margin-right: 15px; margin-bottom: 0">Müraciətin təsnifatı:</p>

                  <div style="display: flex">
                    <a-tag
                      v-for="category in getCategoriesOfProblem"
                      :key="category.uuid"
                      color="#108ee9"
                      style="display: flex; align-items: center;  white-space: break-spaces;"
                    >
                      {{ category.name }}
                      {{
                        category.parent
                          ? `(${category.parent.name.toLowerCase()})`
                          : ""
                      }}
                    </a-tag>
                  </div>
                </div>
              </a-col>
              <a-col :span="9" class="operation-panel" v-if="problem">
                <!--  <citizen-list :compStyle="{maxHeight:'180px'}" :citizenslist="problem.appeals"></citizen-list> -->
                <div class="detailed">
                  <a-button
                    type="default"
                    @click="showDetailed(problem)"
                    style="text-align: right"
                    >Ətraflı</a-button
                  >
                </div>

                    

                <div v-if="privilege.workWithDetails">
                  <operation-detail
                    ref="operationdetail"
                    :problem="problem"
                    :data="problem.officeDetails"
                    :privilege="privilege"
                    @submit="handleOpSubmit"
                    :whiteList="initialOfficeIds"
                    @removed="handleRemove"
                    :noExecutorWarning="false"
                  />
                </div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>

        <not-found-problem v-if="resNotFound"></not-found-problem>

        <detail-modal
          :visible="modalVisible"
          :problemOb="problem"
          @afterClose="handleModalClose"
        />
      </div>
    </a-spin>
  </a-layout-content>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
// import { mapGetters, mapMutations, mapActions } from "vuex";
import mixin from "@/mixins/index";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
import moment from "moment";
import DetailModal from "@/components/pages/Modals/DetailModal/index";
import CitizenList from "@/components/partials/CitizenList/index";
import NotFoundProblem from "@/components/partials/NotFoundProblem";
import ProblemHeader from "@/components/partials/ProblemHeader/index";
import OperationDetail from "@/components/partials/OperationDetail/index";

export default {
  name: "ExecuteDetails",
  mixins: [mixin],
  components: {
    "conditional-media": ConditionalMedia,
    "detail-modal": DetailModal,
    "citizen-list": CitizenList,
    "not-found-problem": NotFoundProblem,
    "problem-header": ProblemHeader,
    "operation-detail": OperationDetail,
  },
  data() {
    return {
      problem: null,
      executors: [],
      complaint: {
        details: [],
      },
      modalVisible: false,
      executeLastDate: null,
      selectedExecutorUUID: null,
      buttons: [],
      files: [],
      fileList: [],
      initialOfficeIds: [],
      action: URL[process.env.NODE_ENV].service_api + "files",
      resNotFound: false,
      executorInfoHead: null,
    };
  },
  computed: {
    getCategoriesOfProblem: function () {
      const categories = this.problem ? this.problem.categories : [];
      return categories;
    },
  },
  watch: {
    // problem: {
    //   immediate: true,
    //   handler: function(newVal) {
   
    //   }
    // },
    getCategories: {
      immediate: true,
      handler: function (newVal) {
        
      },
    },
  },
  methods: {
    moment,
    goBack() {
      this.$router.push("/main");
    },
    handleRemove(OperationDetail) {
    
    },
    handleUploadChange({ fileList }) {
      this.fileList = fileList;
    },
    handleOpSubmit({ button, detailOffice,commentarStructures, result }) {
      this.submit(button, detailOffice,commentarStructures, result);
    },
    disabledDate(current) {
      return current && current < moment().endOf("day");
    },
    newExecutor() {
      this.executorModalVisiblity = true;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    showConfirm(sendData, detailOffice) {
      const problem = this.problem;
      const message = this.$message;
      const destroyAll = this.destroyAll;
      this.$confirm({
        title: "Əlavə edilsin?  ",
        //content: "",
        okText: "Bəli ",
        okType: "primary",
        cancelText: "Xeyr",
        onOk() {
          return new Promise((resolve, reject) => {
            apiCall({
              url:
                URL[process.env.NODE_ENV].service_api +
                "problems/" +
                problem.id,
              method: "PUT",
              data: sendData,
              params: {
                key: (sendData.currentUrl =
                  window.location.pathname.split("/").length === 0
                    ? ""
                    : window.location.pathname.split("/")[1]),
              },
            })
              .then((response) => {
                if (!response.data.error) {
                  message.info("Müraciət göndərildi.");
                  setTimeout(() => {
                    window.location.href = "/main";
                  }, 1000);
                } else {
                  message.error(response.data.error.message);
                  destroyAll();
                }
              })
              .catch((err) => {
                message.error("Xəta baş verdi");
             
                destroyAll();
              });
          }).catch();
        },
        onCancel() {
     
        },
      });
    },
    submit(button, detailOffice,commentarStructures, result) {
      let sendData = this.fillDatas(button, detailOffice);
      if (!sendData) return;
      sendData.result = result;
      sendData.commentarStructures=commentarStructures;
      this.showConfirm(sendData, detailOffice);
    },
    fillDatas(button, detailOffice) {
      let sendData = {
        note: this.privilege.workWithDetails
          ? detailOffice.noteField
          : this.problem.noteField,
        action: button,
        executor: null,
        lastDateStr: null,
        detailOffice: null,
        files: this.privilege.workWithDetails
          ? detailOffice.fileList
          : this.fileList,
      };
      if (button.dataRequired) {
        sendData.executor = { uuid: detailOffice.selectedExecutorUUID };
        sendData.lastDateStr = detailOffice.executeLastDate
          .format(this.opDatetimeFormat)
          .toString();
      }
      if (this.privilege.workWithDetails) {
        sendData.detailOffice = detailOffice;
        sendData.files = detailOffice.fileList;
      }
            if (
        this.privilege.selectSubOffice === "REQUIRED" &&
        (button.dataRequirementStatus === "NECESSARIES" ||
          button.dataRequirementStatus === "ALL")
      ) {
        sendData.subOffice = { id: detailOffice.selectedOfficeId };
        sendData.detailOffice = this.problem.officeDetails[0];
      } else if (
        this.privilege.selectSubOffice === "OPTIONAL" &&
        detailOffice.selectedOfficeId &&
        button.dataRequirementStatus === "ALL"
      ) {
        sendData.subOffice = { id: detailOffice.selectedOfficeId };
        sendData.detailOffice = this.problem.officeDetails[0];
      }
      sendData.currentUrl =
        window.location.pathname.split("/").length === 0
          ? ""
          : window.location.pathname.split("/")[1];
      return sendData;
    },
    showDetailed(detail) {
      this.modalVisible = true;
    },
    handleModalClose() {
      this.modalVisible = false;
    },
    getProblemDetails() {
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "problems/" +
          this.$route.params.id,
        method: "GET",
        params: {
          key:
            window.location.pathname.split("/").length === 0
              ? ""
              : window.location.pathname.split("/")[1],
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.problem = response.data.data;
            this.privilege = this.problem.privilege;
            // this.problem.officeDetails;
            this.problem.officeDetails.forEach((officeDetail) => {
              if (
                officeDetail.executeDetails &&
                officeDetail.executeDetails.length > 0
              ) {
                let executor = officeDetail.executeDetails[0].executor;
                officeDetail.executorInfoHead =
                  executor.firstName +
                  " " +
                  executor.lastName +
                  (executor.mobilePhoneNumber
                    ? "(" + executor.mobilePhoneNumber + ")"
                    : "");
                this.$set(officeDetail, "selectedExecutorUUID", executor.uuid);
                this.$set(
                  officeDetail,
                  "executeLastDate",
                  moment(
                    officeDetail.executeDetails[0].lastDateStr,
                    this.showDatetimeFormat
                  )
                );
                this.$set(
                  officeDetail,
                  "timeFinished",
                  officeDetail.executeDetails[0].delayTime > 0
                );
                this.$set(
                  officeDetail,
                  "delayTimeStr",
                  this.calculateDayAndHour(officeDetail.executeDetails[0])
                );
                if (officeDetail.category)
                  this.$set(
                    officeDetail,
                    "selectedCategoryUUID",
                    officeDetail.category.uuid
                  );
              }
            });
          } else if (response.data.error.code === 1080) {
            this.$message.error(response.data.error.message);
            this.resNotFound = true;
          }
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
        
        });
    },
  },
  async created() {
    this.pageLoading = true;
    this.getExecutors();
    this.getProblemDetails();
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
